<template>
  <div class="h-screen w-full p-8">
    <app-header/>
    <div class="flex flex-row w-full items-center justify-center mb-2">
      <h4>Inscripción</h4><br>
    </div>
    <div class="flex flex-row w-full items-center justify-center mb-2">
      <h1><b>{{ eventData.name }}</b></h1>
    </div>
    <div class="flex flex-row w-full items-center justify-center mb-4">
      <h5>{{ eventData.description }}</h5>
    </div>
    <div class="flex flex-row w-full items-center justify-center" v-show="eventData.id > 0 && registrationId === 0">
      <vs-card class="flex flex-col">
        <div slot="header" class="flex w-full flex-col">
          <h4>Por favor ingrese sus datos</h4>
        </div>
        <div class="flex w-full flex-row">
          <div class="w-1/5 mr-3">
            <ejs-textbox floatLabelType="Auto" placeholder="Código EA (en blanco si no tiene)" v-model="code" @blur="checkCode" ref="firstItem"/>
          </div>
          <div class="w-1/5 mr-3">
            <ejs-maskedtextbox floatLabelType="Auto" placeholder="DPI" v-model="data.dpi" mask="0000000000000"/>
          </div>
          <div class="w-1/5 mr-3">
            <ejs-textbox floatLabelType="Auto" placeholder="Código SIB (en blanco si no tiene)" v-model="data.sibCode"/>
          </div>
        </div>
        <div class="flex w-full flex-row">
          <div class="w-1/2 mr-3">
            <ejs-textbox floatLabelType="Auto" placeholder="Nombres" v-model="data.firstName"/>
          </div>
          <div class="w-1/2">
            <ejs-textbox floatLabelType="Auto" placeholder="Apellidos" v-model="data.lastName"/>
          </div>
        </div>
        <div class="flex w-full flex-row">
          <div class="w-1/5 mr-3">
            <ejs-maskedtextbox floatLabelType="Auto" placeholder="Número de teléfono" v-model="data.phone" mask="00000000"/>
          </div>
          <div class="w-2/5 mr-3">
            <ejs-textbox floatLabelType="Auto" placeholder="Correo electrónico" v-model="data.email"/>
          </div>
          <div class="w-1/5">
            <ejs-maskedtextbox floatLabelType="Auto" placeholder="Número de licencia de conducir" v-model="data.driversLicense" mask="0000000000000"/>
          </div>
        </div>
        <div class="flex w-full flex-row mb-5">
          <div class="w-2/5">
            <ejs-dropdownlist
              ref="partner"
              floatLabelType="Auto"
              placeholder="Empresa (escriba una parte del nombre para encontrarla)"
              highlight=true
              v-model="data.partnerId"
              :dataSource="partners"
              :fields="{text: 'name', value: 'id'}"
              :query='partnerQuery'
              allowFiltering=true
              :filtering='partnerFiltering'
            />
          </div>
        </div>
        <div slot="footer" class="flex justify-end" v-if="registrationId === 0">
          <vs-button icon="close" size="large" to="/" color="danger" class="mr-2">Cancelar</vs-button>
          <vs-button icon="save" size="large" @click="save()">Guardar datos e inscribir</vs-button>
        </div>
      </vs-card>
    </div>
    <div class="flex flex-row w-full items-center justify-center" v-if="registrationId > 0">
      <vs-card class="flex flex-col">
        <div slot="header" class="flex w-full flex-col">
          <h4>Inscripción registrada</h4>
        </div>
        <div class="flex w-full flex-col items-center justify-center mb-10">
          <h2>Número de inscripción: <b>{{ registrationId }}</b></h2>
          <span>Nombre: {{ data.firstName}} {{ data.lastName }}</span>
          <span>Fecha de inscripción: {{ toDate(registrationDate) }}</span>
        </div>
        <div slot="footer" class="flex justify-end">
          <vs-button icon="done" size="large" to="/">Aceptar</vs-button>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
  import Vue from "vue";
  import {Query} from "@syncfusion/ej2-data";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {MaskedTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {DropDownListPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {firebase, db} from '@/firebaseConfig';

  Vue.use(TextBoxPlugin);
  Vue.use(MaskedTextBoxPlugin);
  Vue.use(DropDownListPlugin);

  export default {
    data() {
      return {
        loaded: false,
        registrationId: 0,
        registrationDate: null,
        eventData: {
          id: 0,
          name: '',
          description: ''
        },
        code: '',
        data: {
          id: 0,
          code: '',
          sibCode: '',
          dpi: '',
          firstName: '',
          lastName: '',
          phone: '',
          email: '',
          driversLicense: '',
          partnerId: 0,
          partnerName: '',
          active: false,
          activeFrom: new Date(),
          activeThru: new Date()
        },
        partnerQuery: new Query().select(['name', 'id']).take(50),
      }
    },
    components: {
      AppHeader: () => import('./Header')
    },
    watch: {
      '$route.path': function () {
        this.validateRoute(this.$route);
      }
    },
    computed: {
      api() {
        return this.$store.getters.getParameter('connection').apiURL;
      },
      partners() {
        return this.$store.getters.partnersList;
      },
      events() {
        return this.$store.state.events;
      },
      selectedPartner() {
        return this.$store.getters.getPartner(this.data.partnerId);
      }
    },
    methods: {
      toDate(date) {
        return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`;
      },

      validateRoute(route) {
        if (route.name == 'registration') {
          if (route.hasOwnProperty('params')) {
            if (route.params.hasOwnProperty('id')) {
              const eventData = this.$store.getters.getEvent(route.params.id);
              if (eventData) {
                this.eventData = eventData;
                this.$refs.firstItem.focusIn();
              } else {
                this.$router.push('/');
              }
            }
          }
        }
      },

      partnerFiltering: function (e) {
        var searchData = JSON.parse(JSON.stringify(this.partners));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          var query = new Query().select(['name', 'id']);
          query = (e.text !== '') ? query.where('name', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },

      checkCode() {
        if (this.code.trim() == '') {
          this.data = {
            id: 0,
            code: '',
            sibCode: '',
            dpi: '',
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            driversLicense: '',
            partnerId: 0,
            partnerName: '',
            active: false,
            activeFrom: new Date(),
            activeThru: new Date()
          };
        } else {
          const self = this;
          let agent = null;
          db.collection('agents')
            .where('code', '==', this.code)
            .orderBy('id')
            .get()
            .then(querySnapshot => {
              querySnapshot.forEach(function (doc) {
                agent = doc.data();
              });
              if (agent) {
                self.data = {
                  id: agent.id,
                  code: agent.code,
                  sibCode: agent.sibCode,
                  dpi: agent.dpi,
                  firstName: agent.firstName,
                  lastName: agent.lastName,
                  phone: agent.phone,
                  email: agent.email,
                  driversLicense: typeof agent.driversLicense == 'undefined' ? '' : agent.driversLicense,
                  partnerId: agent.partnerId,
                  partnerName: typeof agent.partnerName == 'undefined' ? '' : agent.partnerName,
                  active: agent.active,
                  activeFrom: agent.activeFrom.toDate(),
                  activeThru: agent.activeThru.toDate()
                };
              } else {
                self.$vs.notify({
                  title: 'Error al buscar agente',
                  text: `El código ${self.code} no fue encontrado`,
                  color: 'danger'
                });
              }
            });
        }
      },

      validateEmail(email) {
        // eslint-disable-next-line
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
      },

      updateRegistration(id, agentId) {
        const self = this;
        this.registrationDate = new Date();
        db.collection('registrations').doc(id).set({
          id: parseInt(id),
          eventId: this.eventData.id,
          eventName: this.eventData.name,
          date: this.registrationDate,
          agentId: parseInt(agentId),
          firstName: this.data.firstName,
          lastName: this.data.lastName,
          phone: this.data.phone,
          email: this.data.email,
          partnerId: this.data.partnerId,
          partnerName: this.selectedPartner ? this.selectedPartner.name : ''
        }, {merge: true})
          .then(function () {
            self.registrationId = parseInt(id);
            self.$vs.loading.close();
          })
          .catch(error => {
            self.$vs.loading.close();
            self.$vs.notify({
              title: 'Ocurrió un error al cuardar inscripción',
              text: error,
              color: 'danger'
            });
          });
      },

      updateAgent(id) {
        const self = this;
        db.collection('agents').doc(id).set({
          code: this.data.code,
          sibCode: this.data.sibCode,
          dpi: this.data.dpi,
          firstName: this.data.firstName,
          lastName: this.data.lastName,
          phone: this.data.phone,
          email: this.data.email,
          driversLicense: this.data.driversLicense,
          partnerId: this.data.partnerId,
          partnerName: this.selectedPartner ? this.selectedPartner.name : ''
        }, {merge: true})
          .then(function () {
            db.collection('registrations')
              .where('eventId', '==', self.eventData.id)
              .where('agentId', '==', parseInt(id))
              .orderBy('id')
              .get()
              .then(querySnapshot => {
                let registrationId = null;
                querySnapshot.forEach(function (doc) {
                  registrationId = doc.id;
                });
                if (registrationId) {
                  self.updateRegistration(registrationId, id);
                } else {
                  db.collection('parameters').doc('sequences').update({registrations: firebase.firestore.FieldValue.increment(1)})
                    .then(() => {
                      db.collection('parameters').doc('sequences').get()
                        .then(doc => {
                          if (doc.exists) {
                            const registrationId = doc.data().registrations.toString();
                            self.updateRegistration(registrationId, id);
                          }
                        });
                    })
                    .catch(error => {
                      self.$vs.loading.close();
                      self.$vs.notify({
                        title: 'Ocurrió un error al cuardar inscripción',
                        text: error,
                        color: 'danger'
                      });
                    });
                }
              });
          })
      },
      save() {
        let message = '';
        if (this.data.dpi.trim() == '') {
          message = 'Debe especificar DPI';
        }
        if (this.data.firstName.trim() == '') {
          message += (message == '' ? '' : '<br>') + 'Debe especificar nombres';
        }
        if (this.data.lastName.trim() == '') {
          message += (message == '' ? '' : '<br>') + 'Debe especificar apellidos';
        }
        if (this.data.phone.trim() == '') {
          message += (message == '' ? '' : '<br>') + 'Debe indicar número de teléfono';
        }
        if (this.data.email.trim() == '') {
          message += (message == '' ? '' : '<br>') + 'Debe indicar dirección de correo electrónico';
        }
        if (this.data.driversLicense.trim() == '') {
          message += (message == '' ? '' : '<br>') + 'Debe indicar número de licencia de conducir';
        }
        if (this.data.partnerId == 0) {
          message += (message == '' ? '' : '<br>') + 'Debe seleccionar una empresa';
        }
        if (!this.validateEmail(this.data.email)) {
          message += (message == '' ? '' : '<br>') + 'Dirección de correo electrónico incorrecta';
        }
        if (message == '') {
          this.$vs.loading({
            text: 'Guardando inscripción, por favor espere',
            type: 'point'
          });
          const self = this;
          let id = null;
          if (this.code.trim() == '') {
            db.collection('parameters').doc('sequences').update({agents: firebase.firestore.FieldValue.increment(1)})
              .then(() => {
                db.collection('parameters').doc('sequences').get()
                  .then(doc => {
                    if (doc.exists) {
                      id = doc.data().agents;
                      self.updateAgent(id.toString());
                    }
                  })
                  .catch(error => {
                    self.$vs.loading.close();
                    self.$vs.notify({
                      title: 'Ocurrió un error al cuardar inscripción',
                      text: error,
                      color: 'danger'
                    });
                  });
              });
          } else {
            db.collection('agents')
              .where('code', '==', this.code)
              .orderBy('id')
              .get()
              .then(querySnapshot => {
                querySnapshot.forEach(function (doc) {
                  id = doc.id;
                });
                if (id) {
                  self.updateAgent(id);
                } else {
                  self.$vs.loading.close();
                  self.$vs.notify({
                    title: 'Error al buscar agente',
                    text: `El código ${self.code} no fue encontrado`,
                    color: 'danger'
                  });
                }
              })
              .catch(error => {
                self.$vs.loading.close();
                self.$vs.notify({
                  title: 'Ocurrió un error al cuardar inscripción',
                  text: error,
                  color: 'danger'
                });
              });
          }
        } else {
          this.$vs.notify({
            title: 'Error en ingreso de datos',
            text: message,
            color: 'danger'
          });
        }
      }
      /*
            async registrationList() {
              const registrations = await db.collection('registrations').get();
              const json = JSON.stringify(registrations.docs.map((doc) => ({ ...doc.data() })));
              console.log(json);
            }
      */
    },
    mounted() {
      const self = this;
      // this.registrationList();
      setTimeout(function () {
        self.validateRoute(self.$route);
      }, 1250);
    }
  }
</script>

<style>
  @import '../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  @import '../../node_modules/@syncfusion/ej2-dropdowns/styles/material.css';
</style>
